export const JOBS_COMBOS_IDS = [
  'jobs_target',
]
